// Todo: Add interface for option
export const filterSelectorOption = (inputValue: string, option: any) => {
    const label = option?.label?.toString().toLowerCase() ?? '';
    return label.includes(inputValue.toLowerCase());
};
